import { AccountType } from 'src/utils/enums/payment.enum';
import { formatMoney } from 'src/utils/formatMoney';
import { QuoteDetails } from 'src/services/models/payment.service';
import { useLocalization } from 'src/utils/useLocalization';
import { formatDate, formatDateAndTime } from 'src/utils/formatDate';

interface IProps {
    quoteDetails: QuoteDetails;
    accountType: AccountType;
}

const ListItem: React.FC<{ value: string; title: string }> = ({
    value,
    title,
}) => {
    const style = {
        color: '#000000',
    };
    return (
        <div className='c-description-list__group no-flex-wrap'>
            <dt className='c-description-list__term' style={style}>
                {title}
            </dt>
            <dd className='c-description-list__detail'>
                <span className='c-description-list__text bold'>{value}</span>
            </dd>
        </div>
    );
};

const QuoteInformation: React.FC<IProps> = ({ quoteDetails, accountType }) => {
    const { payoffQuoteInformation } = useLocalization();

    const goodThroughDate = {
        value: formatDate(quoteDetails.goodThroughDate),
        title: payoffQuoteInformation.GOOD_THROUGH_DATE,
    };
    const quoteDate = {
        value: formatDateAndTime(quoteDetails.quoteDate),
        title: payoffQuoteInformation.QUOTE_DATE,
    };

    const fillLeftList = () => {
        if (
            accountType == AccountType.RetailBalloon ||
            accountType == AccountType.RetailLoan
        ) {
            return [
                {
                    value: formatMoney(quoteDetails.quoteAmount),
                    title: payoffQuoteInformation.QUOTE_AMOUNT,
                },
                quoteDate,
            ];
        } else {
            const taxAmount =
                +quoteDetails.residualTax +
                +quoteDetails.taxOnFees +
                +quoteDetails.pastDueTaxAmt +
                +quoteDetails.futurePaymentTaxAmt;
            const amountBeforeTax = +quoteDetails.quoteAmount - taxAmount;
            return [
                {
                    value: formatMoney(amountBeforeTax),
                    title: payoffQuoteInformation.AMOUNT_BEFORE_TAX,
                },
                {
                    value: formatMoney(taxAmount),
                    title: payoffQuoteInformation.TAX_AMOUNT,
                },
                {
                    value: formatMoney(quoteDetails.quoteAmount),
                    title: payoffQuoteInformation.TOTAL_QUOTE_AMOUNT,
                },
            ];
        }
    };

    const fillRightList = () => {
        if (
            accountType == AccountType.RetailBalloon ||
            accountType == AccountType.RetailLoan
        ) {
            return [goodThroughDate];
        } else {
            return [goodThroughDate, quoteDate];
        }
    };

    const leftList = fillLeftList();
    const rightList = fillRightList();

    return (
        <section className='c-form-section'>
            <div className='c-form-section__content'>
                <div className='title'>
                    <h6>
                        <span className='c-section-heading__title-text'>
                            {payoffQuoteInformation.TITLE}
                        </span>
                    </h6>
                </div>
                <div className='o-layout dl-grid-container u-mt-large'>
                    <div className='u-p-none o-layout__item u-1/1 u-mt-none'>
                        <dl className='c-description-list c-description-list--horizontal mb-s'>
                            {leftList.map((item) => (
                                <ListItem
                                    value={item.value}
                                    title={item.title}
                                    key={item.title}
                                />
                            ))}
                        </dl>
                    </div>
                    <div className='o-layout__item u-1/1 u-mt-none'>
                        <dl className='c-description-list c-description-list--horizontal'>
                            {rightList.map((item) => (
                                <ListItem
                                    value={item.value}
                                    title={item.title}
                                    key={item.title}
                                />
                            ))}
                        </dl>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default QuoteInformation;
